import { useTranslation } from 'react-i18next';

import { ForecastPaginatedTable } from 'src/features/forecastPaginated/forecastPaginatedTable/ForecastPaginatedTable';
import { ForecastPaginatedTableSkeleton } from 'src/features/forecastPaginated/forecastPaginatedTable/ForecastPaginatedTableSkeleton';
import type { ForecastDataPoint } from 'src/types/domain/ForecastDataPoint';

type ForecastPaginatedTableContainerProps = {
  sessionId?: string;
  sku?: string | null;
  data: ForecastDataPoint[];
  isLoading: boolean;
  editable?: boolean;
};

export function ForecastPaginatedTableContainer({
  sessionId,
  sku,
  data,
  isLoading,
  editable = true,
}: ForecastPaginatedTableContainerProps) {
  const { t } = useTranslation('forecast');

  return (
    <div className='w-full'>
      {isLoading || !sku || !sessionId ? (
        <ForecastPaginatedTableSkeleton />
      ) : data.length === 0 ? (
        <div className='flex h-32 w-full items-center justify-center rounded-md text-layout-foreground-secondary'>
          {t('No data available')}
        </div>
      ) : (
        <ForecastPaginatedTable
          data={data}
          editable={editable}
          sessionId={sessionId}
          sku={sku}
        />
      )}
    </div>
  );
}
